import ApiService from '@/services/CommonApiService.js'

export const namespaced = true
export const state = {
  products: [],
  selectedProduct: ''
}

export const mutations = {
  SET_PRODUCTS(state, value) {
    state.products = value
  },
  SET_SELECTED_PRODUCT(state, value) {
    state.selectedProduct = value
  }
}

export const actions = {
  fetchProduct({ commit }) {
    return ApiService.GetProducts()
      .then(response => {
        commit('SET_PRODUCTS', response.data.data)
        if (!this.state.product.selectedProduct && response.data.data.length) {
          commit('SET_SELECTED_PRODUCT', response.data.data[0])
        }
      })
      .catch(() => {
        //console.log('IN Catch: ')
      })
  }
}
